import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../store';
import {UserSubscription} from "../../../../user/user-subscription";
import {PaymentInfoComponent} from "../../../../shared/components/payment-info/payment-info.component";
import {ChosenPlan} from "../../../../shared/components/payment-info/models/plan.model";

@Component({
    selector: 'db-switch-plan-checkout',
    templateUrl: './switch-plan-checkout.component.html',
    styleUrls: ['./switch-plan-checkout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SwitchPlanCheckoutComponent implements OnInit {
  @Input() userSubscription: UserSubscription;
  @Input() demoUser: boolean;
  @Input() annualSubscription: UserSubscription;
  @Input() visitors: string;
  @Input() ssdStorage: string;
  @Input() annualVisitors: string;
  @Input() annualSsdStorage: string;
  @ViewChild(PaymentInfoComponent) paymentInfo: PaymentInfoComponent;
  @Output() onClose = new EventEmitter<boolean>();
  public loading: boolean;
  public plan: ChosenPlan;
  public title: string;
  public expirationDate = new Date();
  public benefits: Array<string>;
  public coupon: any = {};

  constructor(
    private readonly _activeModal: DbActiveModal,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this._activeModal.resize(null, 700);
    this._activeModal.whiteCloseBtn(window.innerWidth > 991);
    this._sendGaEvent();
    const today = new Date(); // Get the current date
    this.expirationDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
    this.benefits = [
      this.annualVisitors + '&nbsp; monthly visitors',
      'Free Cloudflare enterprise CDN',
      this.annualSsdStorage + '&nbsp; SSD storage',
      'Faster website speed',
      'VIP priority support',
      'Email marketing tools<span class="soon ml9"><span class="gradient-color">soon</span></span>'];
    this.title = 'Switch to 10Web’s best plan with <span class="gradient-color">no additional cost!</span>';
    this.plan = {
      id: this.annualSubscription.id,
      title: this.annualSubscription.plan.title,
      price: this.annualSubscription.plan.planPrice,
      type: this.annualSubscription.plan.periodNumber === 1 ? 'month' : 'year'
    };
    this.coupon.couponCode = this.userSubscription.variant === 'a' ?  this.userSubscription.isEcommerce ? this.userSubscription.decreased ? 'decreased_ecommerce' : 'annual_ecommerce' : 'annual_business' : this.userSubscription.isEcommerce ? this.userSubscription.decreased ? 'decreased_ecommerceB' : 'annual_ecommerceB' : 'annual_businessB';
  }

  public dontCloseDialog(): void {
    localStorage.setItem('switchPlanAnnual', '1');
    this._activeModal.hideCloseBtn(true);
  }


  private _sendGaEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Upgrade to Annual flow',
      eventLabel: 'Checkout Step'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


}
